import { Row } from '@tanstack/react-table';
import CheckboxField from 'components/forms/checkboxField/CheckboxField';
import RadioGroupField from 'components/forms/radioGroupField/RadioGroupField';
import {
  DisplayPreArrivalFormField,
  PreArrivalFormFields,
} from 'pages/automations/preArrivalForm/PreArrivalFormTab.types';
import { FIELDS_WITH_MIN_AGE_TO_SHOW } from 'pages/automations/preArrivalForm/PreArrivalFormTab.constants';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FieldValidationCellStyled } from './FieldValidationCell.styles';

const FieldValidationCell = ({
  row,
}: {
  row: Row<DisplayPreArrivalFormField>;
}) => {
  const { t } = useTranslation();
  const { id } = row.original;
  const { watch } = useFormContext();

  const isActive = watch(`${id}.isActive`);

  const isOtherGuestAgeActive = watch(
    `${PreArrivalFormFields.OTHER_GUEST_AGE}.isActive`,
  );

  if (!isActive) {
    return t(
      'pageAutomations.preArrivalForm.informationTable.fieldValidations.hidden',
    );
  }

  return (
    <FieldValidationCellStyled>
      <RadioGroupField
        // new field created just to avoid boolean string conversions
        name={`${id}.validation`}
        options={[
          {
            value: 'REQUIRED',
            label: t(
              'pageAutomations.preArrivalForm.informationTable.fieldValidations.required',
            ),
          },
          {
            value: 'OPTIONAL',
            label: t(
              'pageAutomations.preArrivalForm.informationTable.fieldValidations.optional',
            ),
          },
        ]}
      />

      {FIELDS_WITH_MIN_AGE_TO_SHOW.includes(id as any) &&
        isOtherGuestAgeActive && (
          <CheckboxField name={`${id}.minAgeToShow`}>
            {t(
              'pageAutomations.preArrivalForm.informationTable.fieldValidations.onlyIfAgeGreaterThan',
              { age: 12 },
            )}
          </CheckboxField>
        )}
    </FieldValidationCellStyled>
  );
};

export default FieldValidationCell;
